<template>
  <el-dialog
    title="Pause Settings"
    :visible.sync="dialog_visible"
    @open="onLoad"
    width="75%">

    <!-- <pre class="mini-pre">{{ userdata }}</pre> -->
    <div class="sub-title">Work time (Minutes):</div>
    <div>
      <el-checkbox v-model="clone.enabled">Enable breaks</el-checkbox>
    </div>
    <div class="sub-title">Work time (Minutes):</div>
    <div>
      <el-slider
        v-model="clone.workDuration"
        :min="0"
        :step="5"
        :max="120"
        show-tooltip
        show-input
        :disabled="!clone.enabled">
      </el-slider>
    </div>
    <div class="sub-title">Break time (Minutes):</div>
    <div>
      <el-slider
        v-model="clone.breakDuration"
        :min="0"
        :step="1"
        :max="60"
        show-tooltip
        show-input
        :disabled="!clone.enabled">
      </el-slider>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveSettings">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      dialog_visible: false,
      clone: {}
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),
    userdata() {
      return this.userData;
      // return this.$models.userdata.subscribeNode() // userdata is currently stored in firestore
    }
  },
  methods: {
    ...mapActions('optimizer', [
      'optimizer_trigger'
    ]),
    showModal() {
      this.dialog_visible = true;
    },

    onLoad() {
      console.log("onLoad", this.userData);
      if ( this.userData  && 'workmodeSettings' in this.userData) {
        this.clone = Object.assign({}, this.userData.workmodeSettings)
      }
    },

    onSaveSettings() {
      console.log("onSaveSettings", this.clone);

      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'workmodeSettings'
      }).then(() => {
        console.log( "Successfully updated user availabilitySettings" );
        this.$emit('save');
        this.dialog_visible = false;
        this.optimizer_trigger({})
      });
    },
  }
};
</script>
